<template>
  <q-page class="bg-page q-pa-lg">
    <div class="container-md">
      <!-- Заглавие -->
      <div class="header-section q-mb-lg">
        <div class="text-h6 text-mint text-bold flex items-center">
          Додавање на вработени
        </div>

        <q-btn
          label="Нов вработен"
          icon="add"
          class="btn-filled"
          no-caps
          @click="openDialog()"
        />
      </div>

     <!-- Табела -->
<q-card class="table-card q-pa-md">
  <q-table
    :data="vraboteni"
    :columns="columns"
    row-key="SifraID"
    flat
    dense
    class="table-clean"
    no-data-label="Нема внесени вработени."
    :loading="loading"
    loading-label="Се вчитуваат податоци..."
  >
    <!-- Статус -->
    <template v-slot:body-cell-aktiven="props">
      <q-td align="center">
        <q-badge
          :label="props.row.aktiven ? 'Активен' : 'Неактивен'"
          :color="props.row.aktiven ? 'positive' : 'negative'"
        />
      </q-td>
    </template>

    <!-- Акции -->
    <template v-slot:body-cell-akcii="props">
      <q-td align="center" class="q-gutter-x-sm">
        <q-btn
          flat
          dense
          round
          color="mint"
          icon="edit"
          @click="editDialog(props.row)"
        >
          <q-tooltip>Уреди</q-tooltip>
        </q-btn>

        <q-btn
          flat
          dense
          round
          color="negative"
          icon="delete"
          @click="openDeleteDialog(props.row.SifraID)"
        >
          <q-tooltip>Избриши</q-tooltip>
        </q-btn>
      </q-td>
    </template>
  </q-table>
</q-card>
      <!-- Дијалог -->
      <q-dialog v-model="dialog" persistent>
        <q-card class="q-pa-lg rounded-2xl" style="min-width: 520px; max-width: 95vw;">
          <q-card-section class="text-center text-mint text-h6">
            {{ editing ? "Уреди вработен" : "Нов вработен" }}
          </q-card-section>

          <q-form @submit.prevent="saveVraboten">
            <q-card-section class="q-gutter-md">
              <!-- Шифра -->
             <q-input
  v-model.number="form.SifraID"
  label="Шифра"
  outlined
  dense
  color="mint"
  :readonly="editing"
  :rules="[(v) => !!v || 'Шифрата е задолжителна']"
  class="required-field"
/>

<q-input
  v-model="form.Naziv"
  label="Име и презиме"
  outlined
  dense
  color="mint"
  maxlength="40"
  :rules="[
    (v) => !!v || 'Внесете име и презиме',
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
  class="required-field"
/>

<q-input
  v-model="form.email"
  label="Е-пошта"
  type="email"
  outlined
  dense
  color="mint"
  maxlength="40"
  :rules="[
    (v) => !!v || 'Внесете е-пошта',
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
  class="required-field"
/>

<q-input
  v-model="form.Tel"
  label="Телефон"
  outlined
  dense
  color="mint"
  maxlength="40"
  :rules="[
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
/>

<q-input
  v-model="form.Adresa"
  label="Адреса"
  outlined
  dense
  color="mint"
  maxlength="40"
  :rules="[
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
/>

<q-input
  v-model="form.UserName"
  label="Корисничко име"
  outlined
  dense
  color="mint"
  maxlength="40"
  :rules="[
    (v) => !!v || 'Внесете корисничко име',
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
  class="required-field"
/>

<q-input
  v-model="form.Password"
  label="Лозинка"
  outlined
  dense
  color="mint"
  :type="showPass ? 'text' : 'password'"
  maxlength="40"
  :rules="[
    (v) => !!v || 'Внесете лозинка',
    (v) => !v || v.length <= 40 || 'Максимум 40 карактери'
  ]"
  class="required-field"
>
  <template v-slot:append>
    <q-icon
      :name="showPass ? 'visibility_off' : 'visibility'"
      class="eye-icon"
      @click="showPass = !showPass"
    />
  </template>
</q-input>

              <q-toggle
                v-model="form.aktiven"
                label="Активен"
                color="mint"
                left-label
              />
            </q-card-section>

            <q-card-actions align="center">
              <q-btn
                label="Откажи"
                flat
                color="negative"
                no-caps
                @click="dialog = false"
              />
              <q-btn
                label="Зачувај"
                type="submit"
                class="btn-filled"
                no-caps
                :loading="saving"
              />
            </q-card-actions>
          </q-form>
        </q-card>
      </q-dialog>

      <!--  Delete dialog со наши копчиња (Избриши / Откажи) -->
      <q-dialog v-model="deleteDialog" persistent>
        <q-card class="q-pa-md rounded-2xl" style="min-width: 420px; max-width: 95vw;">
          <q-card-section class="text-center text-mint text-h6 text-bold">
            Потврда
          </q-card-section>

          <q-card-section class="text-grey-8">
            Дали сакате да го избришете вработениот со шифра: <b>{{ deleteSifra }}</b>?
          </q-card-section>

          <q-card-actions align="center" class="q-gutter-sm">
            <q-btn
              label="Откажи"
              flat
              color="negative"
              no-caps
              @click="deleteDialog = false"
            />
            <q-btn
              label="Избриши"
              class="btn-filled"
              no-caps
              :loading="deleting"
              @click="confirmDelete"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </q-page>
</template>

<script>
import { VraboteniColumns } from "@/services/forms/vraboteni";
import {
  apiGetVraboteni,
  apiAddVraboten,
  apiUpdateVraboten,
  apiDeleteVraboten,
  nextSifraID,
} from "@/services/vraboteniService";

export default {
  name: "Podesuvanja",
  data() {
    return {
      vraboteni: [],
      loading: false,
      saving: false,
      dialog: false,
      editing: false,
      showPass: false,

      //  за delete dialog
      deleteDialog: false,
      deleteSifra: null,
      deleting: false,

      form: this.emptyForm(),

     
    columns: VraboteniColumns,
    };
  },

  methods: {
    emptyForm() {
      return {
        SifraID: null,
        Naziv: "",
        email: "",
        Tel: "",
        Adresa: "",
        aktiven: true,
        UserName: "",
        Password: "",
      };
    },

    async load() {
      this.loading = true;
      try {
        this.vraboteni = await apiGetVraboteni();
      } catch (e) {
        console.error(e);
        this.$q.notify({
          color: "negative",
          icon: "error",
          message: "Грешка при вчитување на вработени.",
        });
      } finally {
        this.loading = false;
      }
    },

    async openDialog() {
      this.form = this.emptyForm();
      this.editing = false;
      this.showPass = false;

      try {
        const list = this.vraboteni?.length ? this.vraboteni : await apiGetVraboteni();
        this.form.SifraID = nextSifraID(list);
      } catch (e) {
        this.form.SifraID = 1;
      }

      this.dialog = true;
    },

    editDialog(row) {
      this.form = { ...row };
      this.editing = true;
      this.showPass = false;
      this.dialog = true;
    },

    async saveVraboten() {
      if (!this.form.SifraID || !this.form.Naziv || !this.form.email || !this.form.UserName || !this.form.Password) {
        this.$q.notify({
          color: "warning",
          icon: "warning",
          message: "Пополнете ги задолжителните полиња.",
        });
        return;
      }

      this.saving = true;
      try {
        if (this.editing) {
          await apiUpdateVraboten(this.form);
          this.$q.notify({ color: "positive", icon: "check", message: "Вработениот е ажуриран." });
        } else {
          await apiAddVraboten(this.form);
          this.$q.notify({ color: "positive", icon: "person_add", message: "Вработениот е додаден." });
        }

        this.dialog = false;
        await this.load();
      } catch (e) {
        console.error(e);
        this.$q.notify({
          color: "negative",
          icon: "error",
          message: "Грешка при зачувување.",
        });
      } finally {
        this.saving = false;
      }
    },

    //  отвори delete dialog 
    openDeleteDialog(SifraID) {
      this.deleteSifra = SifraID;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      this.deleting = true;
      try {
        await apiDeleteVraboten(this.deleteSifra);
        this.$q.notify({ color: "negative", icon: "delete", message: "Вработениот е избришан." });
        this.deleteDialog = false;
        await this.load();
      } catch (e) {
        console.error(e);
        this.$q.notify({
          color: "negative",
          icon: "error",
          message: "Грешка при бришење.",
        });
      } finally {
        this.deleting = false;
      }
    },
  },

  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.bg-page {
  background-color: #f5f8f7;
}
.container-md {
  max-width: 1100px;
  margin: 0 auto;
}
.text-mint {
  color: #0e6b5f !important;
}
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.table-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}
.table-clean thead tr {
  background-color: #f1f6f5;
  color: #0e6b5f;
  font-weight: 600;
}
.q-table tbody tr:hover {
  background-color: #f6fdfb !important;
}
.btn-filled {
  background-color: #0e6b5f !important;
  color: white !important;
  font-weight: 600;
  border-radius: 10px;
  height: 38px;
  padding: 0 18px;
}
.btn-filled:hover {
  background-color: #138a7b !important;
}

.eye-icon {
  cursor: pointer;
  color: #0e6b5f;
  font-size: 20px;
  padding: 2px;
}
:deep(.required-field .q-field__label) {
  display: inline-flex !important;
  align-items: center !important;
}

:deep(.required-field .q-field__label::after) {
  content: " *";
  color: #e53935 !important;
  font-weight: 700;
}
</style>
